export const BASE_URL = '/api/v1';
export const MAP_CONTROLLER_URL = `${BASE_URL}/map`;
export const FIND_CONTROLLER_URL = `${BASE_URL}/find`;
